import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from "../../../components/table/api-table/api-table.component";
import { TabLayoutComponent } from "../../../components/tab-layout/tab-layout.component";

@Component({
  selector: 'app-cities-tab',
  imports: [APITableComponent, TabLayoutComponent],
  providers: [{ provide: TabComponent, useExisting: CitiesTabComponent }],
  templateUrl: './cities-tab.component.html',
  styleUrl: './cities-tab.component.scss',
})
export class CitiesTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Cities');
  public async main(): Promise<void> {}
}
